import React from 'react';
import { useSelector, StateProps } from 'react-redux';
import { 
  Redirect 
} from 'react-router-dom';
import useRouteManager from 'src/utils/customHook/useRouteManager';
// import { BROKERS } from 'src/context/constants/brokerInfo'
// import { useGuess } from 'src/hooks';

interface GuestGuardProps {
  children:any
}


const GuestGuard: React.FC<GuestGuardProps> = ({ children })  => {
  const account = useSelector((state:StateProps) => state.account);
  // const { isBitkubGuess } = useGuess();
  const routeManager = useRouteManager()

  if (account.user !== undefined) {
    return <Redirect to={routeManager.getRedirectPathname("/portfolio")} />;
  }

  // if (isBitkubGuess) {
  //   return <Redirect to={routeManager.getRedirectPathname("/guest/portfolio")} />
  // }

  return children;
}


export default GuestGuard;
